export default __webpack_public_path__ + "static/media/Commander's Boots of the Battlements.abea793d.jpg";